import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CommonServiceService } from '../../shared/services/common-service.service';
import { Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { DecryptionService } from '../../shared/services/decryption.service';

@Component({
  selector: 'app-learn',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './Blog.component.html',
  styleUrl: './Blog.component.scss',
})
export class BlogComponent implements OnInit,AfterViewInit {
  blogs: any[] = [];
  blogdetails: any;
  pageNumber = 1;
  isLoading!: boolean;
  isExpanded: { [key: number]: boolean } = {};
  constructor(
    private blogDataService: CommonServiceService,
    private router: Router,
    private meta: Meta,private decryptionApi: DecryptionService
  ) {}


  ngOnInit(): void {
    this.addMetaTags();
  
  }

  ngAfterViewInit(): void {
    this.blogdata();
  }
  addMetaTags() {
    this.meta.updateTag({
      name: 'description',
      content:
        'Chessx news covers a wide range of topics related to the game of chess. This includes updates on major tournaments, such as the World Chess Championship, Grand Chess Tour, and other international and national competitions. Key highlights often feature match results, game analyses, and player rankings.',
    });
    this.meta.updateTag({
      name: 'keywords',
      content: 'chessx.ai, chess news, latest chess news, chess news india',
    });
    this.meta.updateTag({ name: 'og:title', content: 'chessx.ai chess news' });
    this.meta.updateTag({ name: 'og:type', content: 'chess news' });
    this.meta.updateTag({ name: 'og:url', content: this.router.url });
    // this.meta.updateTag({ name: 'og:site_name', content: 'chessx' });
  }

  toggleText(blogId: number, event: Event) {
    event.preventDefault();
    // this.isExpanded[blogId] = !this.isExpanded[blogId];
  }

  blogdata() {
    this.blogDataService.getBlogs(this.pageNumber).subscribe((data) => {
      const decrypt=  this.decryptionApi.decrypt(data.payload);
      const jsondecrpt=JSON.parse(decrypt);
      this.blogdetails = jsondecrpt;
      this.isLoading = !this.blogdetails;
      this.blogs.push(...this.blogdetails);
    });
  }

  onScroll(event: any) {
    const element = event.target as HTMLElement;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const totalHeight = element.scrollHeight;
    if (this.blogdetails.length == 0 || this.blogdetails.length < 9) {
      return;
    }

    if (scrollPosition >= totalHeight - 1 && !this.isLoading) {
      this.isLoading = true;
      this.pageNumber++;
      this.blogdata();
    }
  }

  blogIddata(id: any) {
    this.router.navigate(['newsetails', id]);
  }
}
